module.exports = __webpack_public_path__ + "roboto-mediumitalic-webfont.34c4b51097eb4ad66612.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-mediumitalic-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-mediumitalic-webfont.woff
// module chunks = styles